import TextAreaField from 'src/components/common/formFields/textAreaField/TextAreaField';
import { componentSizeVariantsEnum } from 'src/constants';
import Label from 'src/components/common/formFields/label/Label';

import './previewField.scss';
import { TPreviewFieldProps } from './previewField.types';

const TextField = ({ id, label, hasCharacterLimit, validations, required, createProgramStep }: TPreviewFieldProps) => {
  return (
    <div key={id} className="dynamic-field">
      <Label required={required}>{label}</Label>
      <div className="dynamic-field__field">
        {' '}
        <TextAreaField
          id={id}
          variant={componentSizeVariantsEnum.SMALL}
          placeholder={label}
          type="text"
          disabled
          {...(hasCharacterLimit && { textLengthLimit: validations.maxCharacters })}
          createProgramStep
        />
      </div>
    </div>
  );
};

export default TextField;
